/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Last_AdminInputs */

const fr_api_last_admin = /** @type {(inputs: Api_Last_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conservez au moins un administrateur actif.`)
};

const en_api_last_admin = /** @type {(inputs: Api_Last_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep at least one active administrator.`)
};

/**
* | output |
* | --- |
* | "Keep at least one active administrator." |
*
* @param {Api_Last_AdminInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_last_admin = /** @type {((inputs?: Api_Last_AdminInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Last_AdminInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_last_admin(inputs)
	return fr_api_last_admin(inputs)
});